<template>
  <li class="preview_single">
    <div class="preview_s_left">
      <h5 class="s_l_h5">
        <span
            :class="[
            queryPort == 'clinic' && 'blue_icon',
            queryPort == 'admin' && 'blue_icon',
            queryPort == 'irdt' && 'purple_icon'
          ]"
            class="s_l_icon"
        ></span>
        {{ $t("casesDetail.publicCases.casesDiagnosis.zdyq") }}
      </h5>
      <div class="s_l_box">
        <template v-for="(item, index) in casesData">
          <div v-if="!item.isHide" :key="index" class="s_l_con">
            <div
                :style="
                language === 'en_US'
                  ? 'min-width: 2.4rem !important'
                  : 'min-width: 1.7rem !important'
              "
                class="s_l_con_left"
            >
              {{
                item.fIndex ? item.fIndex + "." : ""
              }}{{ item.title ? item.title + ":" : "" }}
            </div>
            <div class="s_l_con_right">
              <div
                  v-for="(pItem, pIndex) in item.pList"
                  :key="pIndex"
                  :class="{
                  dib: pItem.dib,
                  [pItem.parentName]: pItem.parentName
                }"
                  class="s_l_con_right_p"
              >
                <p v-if="pItem.value" class="main_theme_color_333 fz14">
                  {{ formatFieldValue(pItem.filed, details) }}
                </p>

                <p
                    v-if="
                    pItem.onlyHeaderText && isShowHeaderText(pItem.childOptions)
                  "
                    class="main_theme_color_333 fz14"
                >
                  {{ pItem.superiorText }}
                </p>

                <template v-if="shouldRenderSagittalAE(+item.fIndex)">
                  <div
                      v-if="details[pItem.filed]"
                      :class="!pItem.secondLevel ? 'r_strong sublevel' : ''"
                  >
                    <div class="main_theme_color_333 fz14">
                      {{ pItem.secondLevel ? pItem.secondLevel + ":" : "" }}
                      {{
                        pItem.secondLevel
                            ? disposeStair(pItem.filed, pItem.inquireKey)
                            : ""
                      }}
                    </div>
                    <div v-if="details[pItem.filed] && pItem.threeOptions">
                      <div
                          v-for="i in disposeSagittal({
                          inquireKey: pItem.inquireKey,
                          key: pItem.filed,
                          threeOptions: pItem.threeOptions
                        })"
                          :key="i"
                          class="main_theme_color_333 fz14"
                          v-html="i"
                      ></div>
                    </div>
                  </div>
                </template>

                <template v-else-if="shouldRenderSagittalI(+item.fIndex)">
                  <div
                      v-if="details[pItem.filed]"
                      :class="pItem.type === 'note' ? 'r_strong sublevel' : ''"
                  >
                    <div class="main_theme_color_333 fz14">
                      {{
                        pItem.type !== "note"
                            ? disposeStair(pItem.filed, pItem.inquireKey)
                            : details[pItem.filed]
                      }}
                    </div>
                  </div>
                </template>

                <template v-else>
                  <template
                      v-if="
                      (+item.fIndex === 10 &&
                      pItem.sublevel &&
                      ['B', 'G', 'H'].includes(productType)
                        ? split(details[pItem.filed], ',').length > 1
                          ? true
                          : details[pItem.filed] === pItem.differentiateKey
                        : true) ||
                        [
                          'upHorizontalRelationshipValue',
                          'downHorizontalRelationshipValue'
                        ].includes(pItem.describeInputKey)
                    "
                  >
                    <span
                        v-if="
                        (pItem.type !== 'note' && details[pItem.filed]) ||
                          pItem.identification
                      "
                        :class="{
                        sublevel:
                          pItem.sublevel &&
                          details[pItem.filed].includes(pItem.differentiateKey),
                        dib: pItem.identification
                      }"
                        class="r_strong fz14"
                    >
                      <span
                          v-if="
                          pItem.identification &&
                            isShowHeaderText(pItem.childOptions)
                        "
                          :class="pItem.className"
                          class="fz14"
                          style="position: relative; top: 2px"
                      >
                        {{ pItem.identification }}
                      </span>

                      <span v-if="pItem.secondLevel" class="mb1rem fz14">
                        {{ pItem.secondLevel }}
                      </span>
                      <span
                          v-if="pItem.superiorText"
                          :class="pItem.className"
                          class="fz14"
                      >
                        {{ pItem.superiorText }}：
                      </span>

                      <template v-if="!pItem.identification">
                        <div
                            :class="pItem.answerClass"
                            class="dib main_theme_color_333 fz14"
                        >
                          <div v-if="pItem.filed === 'gapCorrect'">
                            <div
                                v-for="(p, px) in gapCorrectList"
                                :key="px"
                                class=""
                            >
                              {{ resolutionDisposeText(pItem.inquireKey, p) }}
                            </div>
                          </div>
                          <span
                              v-else
                              class=""
                              v-html="
                              disposeText({
                                inquireKey: pItem.inquireKey,
                                inquireKeys: pItem.inquireKeys,
                                key: pItem.filed,
                                differentiateKey: pItem.differentiateKey,
                                threeOptions: pItem.threeOptions,
                                parentText: pItem.parentText,
                                describeInputKey: pItem.describeInputKey,
                                parentKey: pItem
                              })
                            "
                          >
                          </span>
                          <span v-if="pItem.describeInputKey">
                            {{
                              details[pItem.describeInputKey]
                                  ? (![
                                "downjawMiddleLineNote",
                                "upjawMiddleLineNote"
                              ].includes(pItem.filed)
                                  ? " - "
                                  : "") + details[pItem.describeInputKey]
                                  : ""
                            }}
                            {{
                              [
                                "specify",
                                "improve_middle_move_left_right",
                                "improve_middle_move_left"
                              ].includes(details[pItem.filed]) &&
                              pItem.isShowMM &&
                              details[pItem.describeInputKey]
                                  ? "mm"
                                  : ""
                            }}
                          </span>
                        </div>
                      </template>
                    </span>
                  </template>

                  <div
                      v-if="pItem.type === 'note' && details[pItem.filed]"
                      :style="
                      index === casesData.length - 1 ? { top: '0.3rem' } : {}
                    "
                      class="wsp s_l_con_note"
                  >
                    <span class="r_strong">
                      {{ details[pItem.filed] }} {{ pItem.input ? "mm" : "" }}
                    </span>
                  </div>

                  <ChildrenTeeth
                      v-if="
                      (pItem.key === 'teeth' &&
                        (details[pItem.filed]
                          ? JSON.parse(details[pItem.filed])
                          : '')) ||
                        pItem.showTeeth
                    "
                      :commonTeeth="commonTeeth"
                      :patientType="pItem.type"
                      :readOnly="true"
                      :teethType="pItem.teethType"
                      class="mb40 mt40"
                  />

                  <IntervalCorrect
                      v-if="
                      pItem.key === 'interval' &&
                        ((details[pItem.filed] &&
                          isArray(details[pItem.filed].split(',')) &&
                          details[pItem.filed]
                            .split(',')
                            .includes('reserved_gap')) ||
                          pItem.filed === 'teeth')
                    "
                      ref="intervalCorrect"
                      :commonTeeth="commonTeeth"
                      :productType="productType"
                      :readOnly="true"
                      :uploadIntervalList="uploadIntervalList"
                      class="mt10"
                  />

                  <AdjoinDislodge
                      v-if="
                      pItem.key === 'adjoin' &&
                        get(details, 'crowdCorrectSide') === 'chooseable'
                    "
                      ref="adjoinDislodge"
                      :crowdTeethList="crowdTeethList"
                      :productType="productType"
                      :readOnly="true"
                  />

                  <VeneerTeeth
                      v-if="pItem.veneer === 'veneer' && pItem.showVeneer"
                      :commonTeeth="veneerList"
                      :patientType="pItem.type"
                      :readOnly="true"
                      :teethType="pItem.teethType"
                      class="mb40 mt40"
                  />
                  <YysdTeeth
                      v-if="
                      pItem.filed === 'whetherToPrepareTeeth'
                        ? get(details, 'whetherToPrepareTeeth') === 'true' &&
                          pItem.showYysd
                        : pItem.showYysd
                    "
                      :childKey="pItem.childKey"
                      :commonTeeth="commonTeeth"
                      :readOnly="true"
                      :teethType="pItem.teethType"
                  />

                  <ReserveDinterval
                      v-if="pItem.key === 'reserve' && details[pItem.filed]"
                      ref="intervalCorrect"
                      :commonTeeth="commonTeeth"
                      :crowdTeethList="uploadIntervalList"
                      :readOnly="true"
                      class="mt20"
                  />
                </template>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <full-loading v-show="isLoading"/>
  </li>
</template>

<script>
import FullLoading from "components/full-loading/full-loading";
import {getDictAllList} from "common/api/public";
import ChildrenTeeth from "../../../components/treatment-table/children-teeth/index";
import IntervalCorrect from "../../../components/treatment-table/interval-correct/index";
import AdjoinDislodge from "../children-adjoin-dislodge/index";
import VeneerTeeth from "../../../components/treatment-table/veneers-teeth/index.vue";
import YysdTeeth from "../../../components/treatment-table/yysd-teeth/yysd-teeth.vue";
import {
  get,
  pickBy,
  join,
  map,
  flattenDeep,
  filter,
  each,
  isArray,
  some,
  split
} from "lodash";
import ReserveDinterval from "../../../components/treatment-table/reserve-dinterval/index";
import {mapState} from "vuex";

export default {
  data() {
    return {
      isLoading: true,
      diaKeyObj: {}
    };
  },
  props: {
    casesData: {type: Array, default: () => []},
    details: {type: Object, default: () => ({})},
    commonTeeth: {type: Array},
    veneerList: {type: Array},
    uploadIntervalList: {type: Array},
    crowdTeethList: {type: Array},
    productType: {type: String}
  },
  computed: {
    ...mapState({
      language: state => state.language
    }),
    queryPort() {
      return this.$route.query.port;
    },
    isIRDT() {
      return sessionStorage.getItem("needRTD") === "1";
    },
    gapCorrectList() {
      const rawList = this.details["gapCorrect"]?.split(",") || [];
      // 如果第一个是 reserved_gap 且有多个项，将其翻转（模拟 unshift 效果）
      if (rawList.length > 1 && rawList[0] === "reserved_gap") {
        return [...rawList].reverse();
      }
      return rawList;
    },
    // 简化模板中的复杂判断：fIndex=8 的矢状关系 A/E 产品线
    shouldRenderSagittalAE() {
      return fIndex =>
          fIndex === 8 && !this.isIRDT && ["A", "E"].includes(this.productType);
    },
    // 简化模板中的复杂判断：fIndex=8 的矢状关系 I 产品线
    shouldRenderSagittalI() {
      return fIndex =>
          fIndex === 8 && !this.isIRDT && ["I"].includes(this.productType);
    },
    // 字典键列表（可精简，此处保持原样以确保功能完整）
    dictKeys() {
      return [
        "tooth_problem",
        "tooth_problem_i",
        "underjaw_abnormal_flag",
        "periodontal_disease",
        "tooth_problem_b",
        "to_correct_tooth_upjaw_b",
        "to_correct_tooth_downjaw_b",
        "left_sagittal_relation",
        "right_sagittal_relation",
        "jaw_problem_b",
        "tooth_problem_two",
        "jaw_problem_two",
        "bad_habits",
        "sagittal_relation",
        "improve_molar",
        "dentition",
        "to_correct_tooth_jaw",
        "up_horizontal_relationship",
        "down_horizontal_relationship",
        "up_horizontal_expansion",
        "down_horizontal_expansion",
        "cover_info",
        "overbite_info",
        "correct_open_b",
        "correct_deep_cover_b",
        "updown_jaw",
        "front_tooth_info_b",
        "correct_front_reverse",
        "back_tooth_info",
        "back_tooth_info_correct_b",
        "choose_option_b",
        "angle_classification",
        "sagittal_maxillomandibular_classification",
        "clinic_info",
        "middle_line",
        "improve_middle_move",
        "to_correct_tooth_downjaw",
        "tooth_extraction",
        "choose_option",
        "choose_option_b",
        "upjaw_far",
        "downjaw_far",
        "non_moveable_teeth",
        "not_available_for_attachments",
        "tooth_problem_c",
        "crowd_correct",
        "tooth_problem_two_c",
        "tooth_problem",
        "jaw_problem",
        "jaw_problem_two",
        "tooth_problem_two",
        "angle_classification",
        "sagittal_maxillomandibular_classification",
        "clinic_info",
        "bad_habits",
        "dentition",
        "to_correct_tooth_jaw",
        "to_correct_tooth_upjaw",
        "to_correct_tooth_downjaw",
        "non_moveable_teeth",
        "not_available_for_attachments",
        "sagittal_relation",
        "left_sagittal_relation",
        "right_sagittal_relation",
        "improve_tip",
        "precision_cut",
        "updown_jaw_gap_correct",
        "gap_correct",
        "underjaw_abnormal_flag",
        "grow_nail_flag",
        "grow_nail_position",
        "grow_nail_purpose",
        "improve_molar",
        "up_horizontal_relationship",
        "down_horizontal_relationship",
        "up_horizontal_expansion",
        "down_horizontal_expansion",
        "cover_info",
        "overbite_info",
        "correct_open",
        "correct_deep_cover",
        "updown_jaw",
        "front_tooth_info",
        "correct_front_reverse",
        "back_tooth_info",
        "back_tooth_info_correct",
        "correct_front_reverse_two",
        "correct_front_opposite",
        "choose_option_b",
        "middle_line",
        "improve_middle_move",
        "to_correct_tooth_downjaw",
        "tooth_extraction_options",
        "choose_option",
        "choose_option_b",
        "upjaw_far",
        "downjaw_far",
        "non_moveable_teeth",
        "need_passive_appliance",
        "erupted_compensate",
        "accept_wisdom_teeth_extraction",
        "accept_premolars_extraction",
        "accept_decayed_teeth_extraction",
        "accept_ipr",
        "undergo_teeth_restoration",
        "implant_anchorage_placement",
        "cbct_photography",
        "orthodontics_treatment_before",
        "original_teeth_color",
        "target_color",
        "surface_texture",
        "design_request_one",
        "design_request_two",
        "clinic_info_f",
        "occlusal_relationship",
        "adjacent_gap",
        "tooth_problem_three",
        "original_teeth_color_f",
        "ivoclar",
        "vita",
        "target_color",
        "target_type",
        "target_transparency",
        "material_type",
        "whether_to_prepare_teeth",
        "veneer_thickness_requirements",
        "surface_texture",
        "design_request_one_f",
        "design_request_two_f",
        "special_instructions",
        "silicone_rubber_model"
      ];
    }
  },
  methods: {
    join,
    map,
    flattenDeep,
    filter,
    get,
    isArray,
    split,
    // --- 核心业务方法 ---

    // 格式化字段值：用于特殊字段的直接转换
    formatFieldValue(field, details) {

      if (field === "needGravityBuckle") {
        return (
            {
              true: this.$t("cases.createUser.s"),
              false: this.$t("cases.createUser.f")
            }[details.needGravityBuckle] || details.needGravityBuckle
        );
      }
      return details[field];
    },
    // 判断是否有子选项需要展示（用于superiorText/headerText）
    isShowHeaderText(keyList) {
      return some(keyList, item => this.details[item]);
    },

    // 字典数据处理：将扁平化的字典列表转换为以 parentKey 为键的对象
    processDictData(data) {
      const obj = {};
      data.forEach(item => {
        // 简化原有的 O(N^2) 过滤逻辑
        if (!obj[item.parentKey]) {
          obj[item.parentKey] = [];
        }
        obj[item.parentKey].push(item);
      });
      this.diaKeyObj = obj;
    },

    // 针对 Sagittal 相关的三级选项渲染逻辑（从 disposeText 中提取）
    handleThreeOptions({item, inquireKey, details}) {
      const i18n = key => this.$t(key); // 简化 i18n 调用

      return filter(
          map(item.threeOptions, three => {
            if (item.key === three.parentKey) {
              const resultKey = details[three.key]?.split(",");
              if (!resultKey || resultKey.length === 0) return null;

              let childKeys = [];
              map(this.diaKeyObj[three.inquireKey], i => {
                if (resultKey.includes(i.key)) {
                  childKeys.push(i.value);
                }
              });

              // 特殊处理 'tooth_extraction'
              if (["tooth_extraction"].includes(item.key)) {
                const str = childKeys.join("、");
                return `${item.value} ${str ? "-" + str : ""}`;
              }

              // 一般三级选项处理
              const suffixKey = {
                rightSagittalRelationFar: "cases.createDiagnosis.yjdjzzyymy",
                leftSagittalRelationFar: "cases.createDiagnosis.yjdjzzyymy"
              }[three.key];

              const suffixText = suffixKey ? i18n(suffixKey) : "";

              return `${item.value} - ${childKeys.join("、")}${suffixText}`;
            }
            return null;
          })
      ).join(" "); // 使用空格分隔多个三级选项（如果有）
    },

    // 核心文本处理方法：从字典中转换 key 列表为描述文本
    disposeText({
                  key,
                  inquireKey,
                  inquireKeys,
                  threeOptions,
                  parentText,
                  describeInputKey,
                  differentiateKey
                }) {
      const details = this.details;
      const keyList = details[key]?.split(",") || [];

      if (!keyList.length) return "";

      // 处理 inquireKeys (多字典查询)
      if (inquireKeys) {
        let returnList = [];
        each(keyList, item => {
          each(inquireKeys, inq => {
            const dict = this.diaKeyObj[inq];
            if (dict) {
              const dia = dict.find(d => item === d.key);
              if (dia) {
                returnList.push(
                    dia.value +
                    (dia.key === "front_tooth_back"
                        ? ` <span class="reset_child">${this.$t(
                            "cases.createDiagnosis.qubtjjl"
                        ) || ""}<span>`
                        : "")
                );
              }
            }
          });
        });
        returnList = Array.from(new Set(returnList));
        return (
            `${parentText ? parentText + " - " : ""}` + returnList.join("、")
        );
      }

      // 处理单个 inquireKey
      const list = filter(
          this.diaKeyObj[inquireKey],
          item => inquireKey === item.parentKey // 实际上这里的过滤是多余的，因为 diaKeyObj 已经按 parentKey 分组
      );

      let returnList = [];

      each(keyList, it => {
        const item = this.diaKeyObj[inquireKey]?.find(d => d.key === it);
        if (!item) return;

        // 1. 特殊处理 improve_molar
        if (inquireKey === "improve_molar") {
          const str = item.key === differentiateKey ? item.value : "";
          returnList.push(str);
          return;
        }

        // 2. 特殊处理横向关系指定值
        if (
            ["down_horizontal_expansion", "up_horizontal_expansion"].includes(
                inquireKey
            ) &&
            item.key === "specify"
        ) {
          const suffix = details[describeInputKey]
              ? ` - ${this.$t("cases.createDiagnosis.total")}`
              : "";
          returnList.push(item.value + suffix);
          return;
        }

        // 3. 处理带三级选项的二级选项
        if (
            threeOptions &&
            [
              "far_grind",
              "bit_jump",
              "tooth_extraction",
              "extend_front_tooth",
              "press_front",
              "press_front_rise_back"
            ].includes(item.key)
        ) {
          const str = this.handleThreeOptions({
            item,
            inquireKey,
            details: this.details
          });
          returnList.push(str);
          return;
        }

        // 4. 默认返回字典值
        returnList.push(item.value);
      });

      // 最终返回处理
      const filteredList = filter(returnList);
      if (
          [
            "overbiteInfoDeep",
            "overbiteInfoOpen",
            "rightSagittalRelationNote",
            "leftSagittalRelationNote"
          ].includes(key)
      ) {
        // 复杂文本拼接（保持原逻辑的逗号/顿号处理）
        let haveThree = [
          "press_front_rise_back",
          "press_front",
          "extend_front_tooth"
        ].includes(keyList[0]);
        let text = "";
        each(filteredList, (it, itx) => {
          text +=
              it +
              (filteredList.length > 1
                  ? haveThree && itx === 0
                      ? ","
                      : itx < filteredList.length - 1
                          ? "、"
                          : ""
                  : "");
        });
        return text;
      } else {
        return filteredList.join("、");
      }
    },

    // 间隙矫治文本转换
    resolutionDisposeText(inquireKey, key) {
      return (
          this.diaKeyObj[inquireKey]?.find(item => item.key === key)?.value || ""
      );
    },

    // 矢状关系二级选项文本（用于 fIndex=8）
    disposeStair(key, inquireKey) {
      const keyList = this.details[key]?.split(",") || [];
      if (!keyList.length) return "";
      return (
          this.diaKeyObj[inquireKey]?.find(item => keyList.includes(item.key))
              ?.value || ""
      );
    },

    // 矢状关系三级选项列表（用于 fIndex=8）
    disposeSagittal({key, inquireKey, threeOptions}) {
      const details = this.details;
      const keyList = details[key]?.split(",") || [];
      if (!keyList.length) return [];

      let returnList = [];

      each(keyList, it => {
        const item = this.diaKeyObj[inquireKey]?.find(d => d.key === it);
        if (!item) return;

        // 处理多个二级选项下有三级选项
        if (
            item.threeOptions &&
            [
              "far_grind",
              "bit_jump",
              "tooth_extraction",
              "extend_front_tooth",
              "press_front",
              "press_front_rise_back"
            ].includes(item.key)
        ) {
          const subOptions = filter(
              map(item.threeOptions, three => {
                if (item.key === three.parentKey) {
                  const resultKey = details[three.key]?.split(",");
                  if (!resultKey || resultKey.length === 0) return null;

                  let childKeys = [];
                  map(this.diaKeyObj[three.inquireKey], i => {
                    if (resultKey.includes(i.key)) {
                      childKeys.push(i.value);
                    }
                  });

                  // 特殊处理 'tooth_extraction'
                  if (["tooth_extraction"].includes(item.key)) {
                    const str = childKeys.join("、");
                    return `${item.value} ${str ? "- " + str : ""}`;
                  }

                  const suffix =
                      item.key === "far_grind"
                          ? `<span class="c-red">${this.$t(
                              "cases.createDiagnosis.yjdjzzyymy"
                          )} </span>`
                          : "";

                  return `${item.value} - ${childKeys.join("、")}${suffix}`;
                }
                return null;
              })
          ).join(); // 使用 join() 来合并三级选项的字符串

          returnList.push(subOptions);
        }
      });
      return returnList;
    }
  },
  async created() {
    this.isLoading = true;
    try {
      const data = await getDictAllList(this.dictKeys);
      this.processDictData(data);
    } catch (error) {
      console.error("Failed to load dictionary data:", error);
    } finally {
      this.isLoading = false;
    }
  },
  components: {
    FullLoading,
    ChildrenTeeth,
    IntervalCorrect,
    AdjoinDislodge,
    ReserveDinterval,
    VeneerTeeth,
    YysdTeeth
  }
};
</script>

<style lang="scss" scoped>
.preview_single {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.51rem;
}

.preview_s_left {
  width: 100%;

  .s_l_h5 {
    display: flex;
    align-items: center;
    margin-bottom: 0.2rem;
    font-size: 16px;
    color: $main_theme_color_333;

    .s_l_icon {
      margin-right: 0.1rem;
      display: inline-block;
      width: 0.24rem;
      height: 0.24rem;
      background-size: 100% 100%;
    }

    .yellow_icon {
      background-image: url("../../../common/imgs/case/case_preview_dia_cion.png");
    }

    .blue_icon {
      background-image: url("../../../common/imgs/user_data/blue_diag.png");
    }

    .purple_icon {
      background-image: url("../../../common/imgs/user_data/purple_diag.png");
    }
  }

  .s_l_box {
    color: #666;
    padding-left: 0.24rem;

    .s_l_box_p {
      display: flex;
      align-items: center;
      margin-bottom: 0.21rem;

      &:last-child {
        margin-bottom: 0;
      }

      span {
        margin-right: 0.2rem;
      }
    }

    .s_l_con {
      display: flex;
      margin-bottom: 0.21rem;
      position: relative;
      line-height: 0.2rem;

      // align-items: center;
      .s_l_con_left {
        width: 1.7rem;
        font-size: 14px;
        color: $main_theme_color_666;
      }

      .s_l_con_right {
        width: 8rem;

        .s_l_con_right_p {
          width: 100%;
          margin-bottom: 0.11rem;

          &:last-child {
            margin-bottom: 0;
          }
        }

        .s_l_con_note {
          width: 100%;
          word-wrap: break-word;
          padding: 0.1rem 0.2rem;
          //background-color: #f3f3f3;
          line-height: 0.2rem;
          border-radius: 4px;
        }

        .r_strong {
          color: $main_theme_color_333;
          position: relative;
          font-size: 14px;
        }
      }
    }
  }

  .pre_list {
    margin-bottom: 0.1rem;
    padding-left: 0.24rem;

    .s_l_txt {
      color: #666;
      margin-bottom: 0.12rem;
    }

    li {
      width: 3.14rem;
      height: 2rem;
      border-radius: 0.06rem;
      background-size: 100% 100%;
      margin-bottom: 0.2rem;

      &:last-child {
        margin-right: 0;
      }
    }

    .pic_list_space {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
    }

    .pic_list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      li {
        margin-right: 0.3rem;
      }
    }
  }
}

.preview_s_right {
  width: 6.3rem;
  height: 0.85rem;
  display: flex;
  align-items: center;
  padding-left: 0.28rem;
  box-sizing: border-box;
  background-color: #f3f3f3;
  border-radius: 0.06rem;

  .preview_s_r_strong {
    font-size: 0.2rem;
    margin-left: 0.1rem;
    margin-right: 0.09rem;
  }

  .preview_s_r_icon {
    display: inline-block;
    width: 0.18rem;
    height: 0.18rem;
    background-color: yellow;
    background-size: 100% 100%;
    cursor: pointer;
  }
}

.sublevel {
  box-sizing: border-box;
  width: 100%;
  padding: 0.1rem 0.2rem;
  display: inline-block;
  background: #f4f4f4;
  border-radius: 4px;
  word-break: break-all;
}

// 15
.header_text {
  width: 0.5rem;
  position: absolute;
  top: 0.12rem;
}

.body_up {
  transform: translateY(-0.34rem);
}
</style>
